
    var riot = require('riot')
    //src: starling/src/tags/comments/new-comment-input.html
riot.tag2('new-comment-input',
  '<img class="avatar avatar--tall comment_user_avatar" riot-src="{getCurrentUser().avatar_url}" alt="{getCurrentUser().display_name}"> <p ref="input" type="text" name="new-comment" class="comment_input" placeholder="{placeholderText()}" onkeydown="{handleKeydown}" onkeyup="{handleKeyUp}" oninput="{handleInput}" onpaste="{handlePaste}" contenteditable="true" required></p>',
  '',
  'show="{isOpen || commentSidebarTag || showPersistentInput()}" class="comment_form" oncontextmenu="{ignoreClick}" onmousedown="{ignoreClick}" ondblclick="{ignoreClick}"', function(opts) {
'use strict';

var _this = this;

var _commentsUi = require('lib/comments-ui');

var _appUi = require('lib/app-ui');

var _constants = require('lib/constants');

var _util = require('lib/util');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas,
    target = _opts.target,
    node = _opts.node,
    selection = _opts.selection,
    position = _opts.position,
    type = _opts.type,
    parentid = _opts.parentid,
    newcommentpanel = _opts.newcommentpanel,
    commenttag = _opts.commenttag,
    commentscontainer = _opts.commentscontainer,
    commentsidebartag = _opts.commentsidebartag;

Object.assign(this, { target: target, node: node, selection: selection, position: position, type: type });

this.parentId = parentid || null;
this.newCommentPanel = newcommentpanel;
this.commentTag = commenttag;
this.commentsContainerTag = commentscontainer;
this.commentSidebarTag = commentsidebartag;

if (this.newCommentPanel) {
  this.newCommentPanel.newCommentInput = this;
}

if (this.commentTag) {
  this.commentTag.newCommentInput = this;
}

if (this.commentSidebarTag) {
  this.commentSidebarTag.newCommentInput = this;
}

if (this.commentsContainerTag) {
  this.commentsContainerTag.newCommentInput = this;
}

this.setTarget = function (_ref) {
  var target = _ref.target,
      node = _ref.node,
      selection = _ref.selection,
      position = _ref.position,
      parentId = _ref.parentId;
  return Object.assign(_this, { target: target, node: node, selection: selection, position: position, parentId: parentId });
};

this.hidePopups = function () {
  return canvas.hidePopups();
};

this.save = function () {
  var target = _this.target,
      selection = _this.selection,
      node = _this.node,
      position = _this.position,
      parentId = _this.parentId;
  var input = _this.refs.input;

  var commentText = input.innerText.trim();

  if (commentText) {
    _this.clearInput();
    _commentsUi.commentsUI.addComment({ commentText: commentText, target: target, selection: selection, node: node, position: position, parentId: parentId });
  }
};

this.addComment = function (event) {
  event.preventDefault();
  var target = _this.target,
      selection = _this.selection,
      node = _this.node,
      position = _this.position,
      parentId = _this.parentId;
  var input = _this.refs.input;

  var commentText = input.innerText.trim();
  _commentsUi.commentsUI.addComment({ commentText: commentText, target: target, selection: selection, node: node, position: position, parentId: parentId });
  _this.clearInput();
  _this.dismiss();
  _this.defocusInput();
};

this.defocusInput = function () {
  var $focused = $(':focus');
  $focused.blur();
  window.getSelection().removeAllRanges();
};

this.showPersistentInput = function () {
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return false;

  // on comments sidebar, no persistent input here
  if (_this.type && _this.type === 'sidebar') return false;

  // on map comments, persistent "reply" input
  if (_this.parentId) {
    var comment = canvas.store.getComment(_this.parentId);
    if (comment && comment.getTarget() === 'map') return true;
  }

  // on card comments, persistent top level comment input
  if (_this.commentsContainerTag) return true;
  return false;
};

this.getCurrentUser = function () {
  return window.user || { avatar_url: '/images/avatar.png' };
};

this.dismiss = function (event) {
  if (event) {
    event.preventDefault();
  }

  if (_this.commentSidebarTag) {
    return _this.clearInput();
  }

  if (_this.commentsContainerTag && _this.commentsContainerTag.getComments().length === 0) {
    return _this.commentsContainerTag.dismiss();
  }

  if (_this.newCommentPanel) {
    return _this.newCommentPanel.hide();
  }

  _this.hide();
};

this.toggle = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (_this.isOpen) {
    _this.hide();
  } else {
    _this.show(params);
  }
};

this.show = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var targetUser = params.targetUser,
      replyTo = params.replyTo;
  var input = _this.refs.input;

  _commentsUi.commentsUI.hideOpenReplyInputs();

  if (!_this.replyTo && replyTo || _this.replyTo !== replyTo) {
    // if we're starting a reply to another reply, replace the contents of the input
    // if the reply button was pressed on the same comment, don't blow away what was typed
    if (targetUser) {
      input.innerHTML = '@' + (targetUser.display_name || targetUser.email) + '&nbsp;';
    } else {
      input.innerText = '';
    }
  }
  _this.replyTo = replyTo;
  _this.isOpen = true;
  _this.update();

  input.focus();
  _this.putCursorAtEnd(input);
};

this.putCursorAtEnd = function (element) {
  var range = document.createRange();
  range.selectNodeContents(element);
  range.collapse(false);
  var selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
};

this.hide = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$save = _ref2.save,
      save = _ref2$save === undefined ? false : _ref2$save;

  if (save) {
    _this.save();
  } else {
    _this.clearInput();
  }
  _this.isOpen = false;
  _this.update();

  if (_this.node) {
    _commentsUi.commentsUI.unsetNewCommentOnNode();
  }
};

this.placeholderText = function () {
  if (_this.parentId) {
    return 'Reply';
  }

  return 'Add a comment…';
};

this.handleKeydown = function (e) {
  e.stopPropagation();
  var ENTER = _constants.KEY_CODES.ENTER,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if (e.keyCode === ESCAPE) {
    _this.clearInput();
    return _this.dismiss();
  }
  if (e.keyCode === ENTER && !e.shiftKey) {
    _this.addComment(e);
  }
};

this.ignoreClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

this.handlePaste = function (e) {
  e.preventDefault();
  if (canvas.isViewOnly() && !canvas.canCommentOnly()) return;
  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData("text/plain")));
  document.execCommand("insertHTML", false, text);
};

this.clearInput = function () {
  var input = _this.refs.input;

  if (input) {
    input.innerText = '';
  }
};

this.on('mount', function () {
  // avoid triggering node drag handlers
  $(_this.refs.input).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('new-comment-input')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/new-comment-input.html
// module id = 780
// module chunks = 0